module.exports = __webpack_public_path__ + "assets/img/duck.eaed1b62.png";